<template>
    <div class="loading-container">
        <i class="el-icon-loading"></i>
    </div>
</template>

<script>
export default {
    name: "loading2",
    data() {
        return {};
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loading-container {
    width: 100vw;
    height: 100vh;
    background: #0000002e;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;

    .el-icon-loading {
        width: 40px;
        height: 40px;
        font-size: 40px;
        color: #666;
        display: block;
        margin: calc(50vh - 20px) calc(50vw - 20px);
    }
    .el-icon-loading:before {
        content: "\E6CF";
        color: #fff;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/loadingtwo.vue